module.exports = __webpack_public_path__ + "static/monitors-596a6b1c0a3e049dc239055bc7ae7578.png";